<div class="container" *ngIf="challenge?.ChallengeType == 1 && challenge?.Rankings?.length == 2">
    <ng-template *ngIf="isDisplayingMygrid; then myGrid else rivalsGrid"></ng-template>
    <ng-template #myGrid>
      <cv-board-ships  [challenge]="challenge"></cv-board-ships>
    </ng-template>
    <ng-template #rivalsGrid>
      <cv-battle-boat-shot [challenge]="challenge"></cv-battle-boat-shot>
    </ng-template>

    <div *ngIf="isPlayerWinner || isPlayerDefeated || isPlayerDraw" class="player-message-status">
      <span class="player-winner" *ngIf="isPlayerWinner" cvLocalizedText langSection="Challenges_Details" langKey="Congratulations_you_win">Congratulations, You Win!</span>
      <span class="player-loser" *ngIf="isPlayerDefeated" cvLocalizedText langSection="Challenges_Details" langKey="Challenge_Lost">Better luck next time, you lose!</span>
      <span class="player-draw" *ngIf="isPlayerDraw" cvLocalizedText langSection="Challenges_Details" langKey="Draw_No_Winners">Draw, no winners in this challenge!</span>
    </div>

    <div class="grid-buttons mt-3" *ngIf="(challenge?.IsRunning || challenge?.ChallengeRewarded) && challenge?.Rankings.length == 2">
        <button class="btn" cvLocalizedText langSection="Challenges_Details" langKey="My_Grid" [title]="localization.get('My_Grid')" [ngClass]="{
          'btn-primary': isDisplayingMygrid,
          'btn-secondary': !isDisplayingMygrid
        }" type="button" (click)="displayMyGrid()">My Grid</button>
        <button class="btn" cvLocalizedText langSection="Challenges_Details" langKey="Rivals_Grid" [title]="localization.get('Rivals_Grid')" [ngClass]="{
          'btn-primary': !isDisplayingMygrid,
          'btn-secondary': isDisplayingMygrid
        }" type="button" (click)="displayRivalGrid()">Rival's Grid</button>
    </div>
</div>